import {
	TableTemplateButtons,
	TableTemplateButtonsEvent,
} from "../components/table/table-template.model";
import { Reminder, IReminder } from "../entities/reminder.model";
import { Formatter } from "../../services/formatter/formatter.service";

/**
 * The two row actions a reminder carries everywhere it is listed — the global
 * Reminders table and Home's worklist (KAN-2555). One definition, so the pencil
 * and Resolve are byte-identical in both places (Maria, 2026-09-22: "exactly the
 * same as what we have in the generic reminders tab ... without having new
 * components").
 */
export const reminderActionButtons = (
	updateFn: (e: TableTemplateButtonsEvent) => void,
	resolveFn: (e: TableTemplateButtonsEvent) => void,
	isResolving = false
): TableTemplateButtons => [
	{
		id: "updateAction",
		className: "p-button-text neutral",
		icon: "pi pi-pencil",
		disabled: false,
		onClick: updateFn,
	},
	{
		id: "resolveAction",
		label: "PARTICIPANTS.REMINDERS.BUTTON_RESOLVE",
		className: "p-button-sm p-button-rounded",
		disabled: isResolving,
		onClick: resolveFn,
	},
];

export enum DateOnNavigation {
	PREV = "PREV",
	NEXT = "NEXT",
}

export type ParticipantsRemindersData = {
	dateOn: Date | null;
	modalIsVisible: boolean;
	onCloseModal: (selectedDate: Date | null) => void;
};

export interface IParticipantReminderRow {
	id: number | null;
	patientId: number;
	kannactId: string;
	coachId: number;
	name: string;
	reason: string;
	dateOn: string; // Date (ISOString)
	createdBy: number | null;
	actionsTemplate: TableTemplateButtons;
	entity: IReminder;
}

export class ParticipantReminderRow implements IParticipantReminderRow {
	id: number | null;
	patientId: number;
	kannactId: string;
	coachId: number;
	name: string;
	reason: string;
	dateOn: string; // Date (ISOString)
	createdBy: number | null;
	assignedTo: number;
	actionsTemplate: TableTemplateButtons;
	entity: Reminder;

	constructor(
		params: IReminder,
		resolveFn: (e: TableTemplateButtonsEvent) => void,
		updateFn: (e: TableTemplateButtonsEvent) => void
	) {
		this.id = params.id;
		this.patientId = params.patientId;
		this.kannactId = params.kannactId;
		this.coachId = params.coachId;
		this.name = Formatter.fullName(params.firstName, params.lastName);
		this.reason = params.reason;
		this.dateOn = params.dateOn;
		this.createdBy = params.createdBy;
		this.assignedTo = params.assignedTo;
		this.actionsTemplate = this.setActionsTemplate(params, resolveFn, updateFn);
		this.entity = params;
	}

	private setActionsTemplate = (
		params: IReminder,
		resolveFn: (e: TableTemplateButtonsEvent) => void,
		updateFn: (e: TableTemplateButtonsEvent) => void
	): TableTemplateButtons => (params.resolved ? [] : reminderActionButtons(updateFn, resolveFn));
}
